<div class="main_header_div">
  <div class="child">
    <h1 class="header_name ">Export Office Attendance</h1>
  </div>
  <div>
    <button class="close-button" (click)="matDialogClose()"><img src="assets/icons/close.png" alt=""></button>
  </div>
</div>
<hr>
<div class="container-fluid">
  <div class="row  main_container body-scroll">
    <div class="filter-container">
    

      <!-- Base Location selection -->
      <mat-form-field appearance="outline">
        <mat-label>Base Location</mat-label>
        <mat-select id="month" [(ngModel)]="selectedBaseLocation">
          <mat-option *ngFor="let location of availableBaseLocation" [value]="location">
            {{ location }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Week selection -->
      <mat-form-field appearance="outline" class="example-full-width week-field">
        <mat-label>Select Week</mat-label>

        <!-- 🔹 Hidden actual datepicker input -->
        <input
          matInput
          [matDatepicker]="weekPicker"
          [(ngModel)]="selectedDate"
          (dateChange)="onDateSelected($event.value)"
          hidden
        />

        <!-- 🔹 Visible display input -->
        <input
          matInput
          [value]="weekDisplay"
          readonly
          (click)="weekPicker.open()"
          placeholder="Choose week"
        />

        <mat-datepicker-toggle matSuffix [for]="weekPicker"></mat-datepicker-toggle>
        <mat-datepicker #weekPicker [dateClass]="dateClasses"></mat-datepicker>
      </mat-form-field>


    </div>


  </div>
  <div class="row">
    <div class="col-md-12 ">
      <div class="main_button_div">
        <button mat-button [disabled]="generateDisabled" class="yes_button"
          (click)="generateReport()">{{generateButtonText}}</button>
      </div>
    </div>
  </div>
</div>
